export const APIS = {
  getMood:
    process.env.NODE_ENV === 'development'
      ? '/user-api/v1/mood/'
      : '/prod/user-api/v1/mood/',
  updateMood:
    process.env.NODE_ENV === 'development'
      ? '/user-api/v1/mood/update/'
      : '/prod/user-api/v1/mood/update/',
  getUser:
    process.env.NODE_ENV === 'development'
      ? '/user-api/v1/user/'
      : '/prod/user-api/v1/user/',
  saveActivity:
    process.env.NODE_ENV === 'development'
      ? '/user-api/v1/activity'
      : '/prod/user-api/v1/activity',
  deleteActivity:
    process.env.NODE_ENV === 'development'
      ? '/user-api/v1/activity/delete/'
      : '/prod/user-api/v1/activity/delete/',
  getFeed:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/feed'
      : '/prod/community-api/v1/feed',
  savePost:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/feed'
      : '/prod/community-api/v1/feed',
  deletePost:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/feed/delete/'
      : '/prod/community-api/v1/feed/delete/',
  getVideos:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/videos'
      : '/prod/community-api/v1/videos',
  saveVideo:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/videos'
      : '/prod/community-api/v1/videos',
  deleteVideo:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/videos/delete/'
      : '/prod/community-api/v1/videos/delete/',
  getLeaderboard:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/leaderboard'
      : '/prod/community-api/v1/leaderboard',
  getPlaylist:
    process.env.NODE_ENV === 'development'
      ? '/community-api/v1/playlist'
      : '/prod/community-api/v1/playlist',
  chatGpt: 'https://api.openai.com/v1/chat/completions',
};
